import React, {Component} from 'react'
import Container from '@material-ui/core/Container';
import { Editor as TMEEditor } from '@tinymce/tinymce-react';
import Editor, { Editable, createEmptyState } from 'ory-editor-core'
import 'ory-editor-core/lib/index.css' // we also want to load the stylesheets
import { Trash, DisplayModeToggle, Toolbar } from 'ory-editor-ui'
import 'ory-editor-ui/lib/index.css'
import slate from 'ory-editor-plugins-slate' // The rich text area plugin
import 'ory-editor-plugins-slate/lib/index.css' // Stylesheets for the rich text area plugin
import parallax from 'ory-editor-plugins-parallax-background' // A plugin for parallax background images
import 'ory-editor-plugins-parallax-background/lib/index.css' // Stylesheets for parallax background images
import image from 'ory-editor-plugins-image'
import 'ory-editor-plugins-image/lib/index.css'
import Paper from '@material-ui/core/Paper'
import spacer from 'ory-editor-plugins-spacer'
import 'ory-editor-plugins-spacer/lib/index.css'
import divider from 'ory-editor-plugins-divider'
import 'ory-editor-plugins-divider/lib/index.css'
// The video plugin
import video from 'ory-editor-plugins-video'
import 'ory-editor-plugins-video/lib/index.css'
// The image plugin
import { imagePlugin } from 'ory-editor-plugins-image'
import 'ory-editor-plugins-image/lib/index.css'

// The background plugin
import background, { COLOR_MODE_FLAG, IMAGE_MODE_FLAG, GRADIENT_MODE_FLAG } from 'ory-editor-plugins-background'
import 'ory-editor-plugins-background/lib/index.css'


// The html5-video plugin
import html5video from 'ory-editor-plugins-html5-video'
import 'ory-editor-plugins-html5-video/lib/index.css'
// The native handler plugin
//import native from '../ory-native-dnd'

import native from 'ory-editor-plugins-default-native'
import ax_ins from '../ajax'
import { Box, FormControlLabel, TextField } from '@material-ui/core';
import Vimeo from '@u-wave/react-vimeo';


// Initialize the app


const isEqual = require("react-fast-compare")

const ImageUploadService = (defaultUrl) => (file, reportProgress) => {
  return new Promise((resolve, reject) => {
  var formData = new FormData()
  formData.append("qqfilename",file.name)
  formData.append("qqfile", file)
  ax_ins.post('upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => console.log(progressEvent.loaded)
  }).then(data => {
    console.log(data.data)
    resolve({ url: 'https://fb.rdheinsberg.de/rest/image/'+data.data.filename})
  })
})
}

const plugins = {
  content: [slate(), spacer, imagePlugin({ imageUpload: ImageUploadService() }), video, divider, html5video],
  layout: [background({
      defaultPlugin: slate(),
      imageUpload: ImageUploadService(),
      enabledModes: COLOR_MODE_FLAG | IMAGE_MODE_FLAG | GRADIENT_MODE_FLAG
    }),
  ],
  native
}



const editarea = {
  width : '80%',
  minHeight : '400px',
  marginLeft : 'auto',
  marginRight : 'auto'
}

const editable = createEmptyState()

const editor = new Editor({
  plugins: plugins,
  // pass the content states
  defaultPlugin: slate(),
  editables: [editable],
})

export default class LectureText extends Component {
  constructor(props){
    super(props)
    this.state = {
      EditorState : createEmptyState(),
      external : false,
      tinycontent : '',
      enableVideo : false,
      //editor : new Editor({ EditorPlugins, defaultPlugin: slate(), editables: [createEmptyState()] })
    }
  }



 componentDidMount () {
   editor.trigger.editable.update(this.props.text || this.state.EditorState)
   this.props.text && this.setState({EditorState : this.props.text})
 }

 componentDidUpdate (prevProps) {
  if (prevProps.text && (prevProps.text.cells !== this.props.text.cells) && this.props.external) {
    this.props.external && this.setState({external: true})
    this.setState({EditorState : this.props.text})
    editor.trigger.editable.update(this.props.text)
    }
    console.log(this.props.text,prevProps.text)
  }

 onTextChange = (e) => {
    if (this.props.text && !isEqual(this.props.text.cells,e.cells) && !this.state.external){
      this.props.onTextChange(e)
      this.setState({EditorState: e})
    }
    if (this.props.text && isEqual(this.props.text.cells,e.cells) && this.state.external){
      this.setState({external: false})
    }
    if (!this.props.text)
      this.props.onTextChange(e)


 }

 handleEditorChange = (content, editor) => {
    this.setState({tinycontent:content})
 }

 saveText = () => {
   console.log('saved pushed')
   let s = this.props.socket
   console.log(this.state.tinycontent)
    s.emit('mod lecturetext',{id:this.props.id,text:this.state.tinycontent})
 }

 saveParameter = (p,v) => {
  let s = this.props.socket
  s.emit('mod lecturetext',{id:this.props.id,text:{...this.props.text,[p]:v}})
 }

   //<HTMLRenderer state={this.props.text} plugins={plugins}/>

  render() {
    return (
      <div>
    {(this.props.editorplugin !== 'tinymce' && this.props.editorplugin !=='video') &&
      <div>
      <Editable editor={editor} onChange={(editable) => {this.onTextChange(editable)}} id={(this.props.text && this.props.text.id) || this.state.EditorState.id} />
      <Trash editor={editor}/>
      <DisplayModeToggle editor={editor}/>
      <Toolbar editor={editor}/>
      </div>
    }
    {this.props.editorplugin == 'tinymce' &&
      <div>
        <input id="my-file" type="file" name="my-file" style={{display:"none"}} onChange="" />
         <TMEEditor
         apiKey="c3e1x3o78hzd3jo184jq0gii2k7t4gpkoy8sdruu257g1qqx"
         initialValue={this.props.text || '<p>Hier Text anlegen</p>'}
         init={{
           height: '80vh',
           save_enablewhendirty: true,
           save_onsavecallback: function () {e=> console.log('test') },
           plugins: [
             'save advlist autolink lists link image charmap print preview anchor',
             'searchreplace visualblocks code fullscreen',
             'insertdatetime media table paste code help wordcount'
           ],
           toolbar:
             'save | undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help',
            file_browser_callback_types: 'image',
             file_picker_callback: function (callback, value, meta) {
               if (meta.filetype == 'image') {
                   var input = document.getElementById('my-file');
                   input.click();
                   input.onchange = function () {
                       var file = input.files[0];
                       var reader = new FileReader();
                       reader.onload = function (e) {
                           console.log('name',e.target.result);
                           callback(e.target.result, {
                               alt: file.name
                           });
                       };
                       reader.readAsDataURL(file);
                   };
               }
           },
             paste_data_images: true,
         }}
         onEditorChange={this.handleEditorChange}
         onSaveContent={this.saveText}
       />
       </div>
    }
    {this.props.editorplugin == 'video' && 
      <Container  maxWidth='lg'>
         <Box>
        <TextField fullWidth label='Vimeo-Link' value={this.props.text?.link} onChange={e => this.saveParameter('link',e.target.value)} onBlur={e => this.setState({enableVideo:true})} />
        </Box>
        <Box>
        {this.props.text?.link && this.state.enableVideo  &&  <Vimeo video={this.props.text.link} />}
        </Box>
        <Box>

        <TextField fullWidth type='number' label='Quiz-Freigabe' helperText='nötige Betrachtungsdauer in Minuten' value={this.props.text?.dur} onChange={e => this.saveParameter('dur',e.target.value)}/>
        </Box>       
        {/* Hier video-link und parameter zu laufzeitgucken und checkpoints */}
      </Container>
    }
    </div>
    )
  }
}
